<template>
    <div class="text-column" :class="props.class">        
        <slot />
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    class: {
        type: String,
        default: ''
    }

})
</script>